<!-- Spinners -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" name="fullScreenSpinner" size="medium" color="#fff" type="ball-rotate"
  [fullScreen]="true">
  <p class="spinner-text">Cargando actividades...</p>
</ngx-spinner>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" name="reloadSpinner" size="medium" color="#fff" type="ball-rotate"
  [fullScreen]="true">
  <p class="spinner-text">Recargando página...</p>
</ngx-spinner>

<!-- Panel -->
<div class="audit-panel">
  <div class="audit-header d-flex flex-column justify-content-center">
    <h1><i class="fas fa-chart-bar"></i> Panel de Auditorías</h1>
    <p>Historial completo de cambios y actividades del sistema</p>
  </div>

  <div class="filters-container">
    <div class="filter-intro">
      <h3>Filtros de Búsqueda</h3>
      <p>Busca registros específicos por fecha y tipo de acción</p>
    </div>

    <div class="filters-flex">


      <div class="filter-item">
        <label class="subtitle">Periodo Inicio:</label>
        <div class="datetime-picker">
          <div class="datetime-picker-item">
            <label>Fecha inicio:</label>
            <p-calendar class="custom-input" [(ngModel)]="dateInit" dateFormat="dd/mm/yy" [maxDate]="dateEnd"
              [appendTo]="'body'" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{strYearRange}}"
              (onSelect)="onTimeChange();" (onBlur)="onTimeChange();" (onInput)="onTimeChange();"
              (onClickOutside)="onTimeChange();"></p-calendar>
          </div>
          <div class="datetime-picker-item">
            <label>Hora inicio:</label>
            <p-calendar class="custom-input" [(ngModel)]="timeInit" [timeOnly]="true" [readonlyInput]="true"
              [maxDate]="timeEnd" [appendTo]="'body'" (onSelect)="onTimeChange();" (onBlur)="onTimeChange();"
              (onInput)="onTimeChange();" (onClickOutside)="onTimeChange();"></p-calendar>
          </div>
        </div>
      </div>

      <div class="filter-item">
        <label class="subtitle">Periodo Hasta:</label>
        <div class="datetime-picker">
          <div class="datetime-picker-item">
            <label>Fecha final:</label>
            <p-calendar class="custom-input" [(ngModel)]="dateEnd" dateFormat="dd/mm/yy" [minDate]="dateInit"
              [appendTo]="'body'" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{strYearRange}}"
              (onSelect)="onTimeChange();" (onBlur)="onTimeChange();" (onInput)="onTimeChange();"
              (onClickOutside)="onTimeChange();"></p-calendar>
          </div>
          <div class="datetime-picker-item">
            <label>Hora final:</label>
            <p-calendar class="custom-input" [(ngModel)]="timeEnd" [timeOnly]="true" [readonlyInput]="true"
              [minDate]="timeInit" [appendTo]="'body'" (onSelect)="onTimeChange();" (onBlur)="onTimeChange();"
              (onInput)="onTimeChange();" (onClickOutside)="onTimeChange();"></p-calendar>
          </div>
        </div>
      </div>

      <div class="filter-item">
        <label for="registro">Registros:</label>
        <p-dropdown class="custom-input" id="registro" [options]="registros" [(ngModel)]="selectedReport"
          optionLabel="value" optionValue="id" [appendTo]="'body'" placeholder="Seleccione el registro..."></p-dropdown>
      </div>

    </div>

    <div class="generate-button-container">
      <button class="btn-generate btn-gl-save btn-dark-hover" (click)="generate();">Generar</button>
    </div>
  </div>
</div>